import React from "react";
import { graphql, useFragment } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { type TreeConfigEditor_TreeNodeFragment$key } from "@relay/TreeConfigEditor_TreeNodeFragment.graphql";
import { StartTreeConfigEditor } from "./StartTreeConfigEditor";
import { VisibilityTreeConfigEditor } from "./visibility-tree-config-editor/visibility-tree-config-editor.component";
import { TREE_I18N_KEY, TREE_I18N_MAP } from "../../../translations/tree";

const TREE_NODE_FRAGMENT = graphql`
	fragment TreeConfigEditor_TreeNodeFragment on TreeNode {
		...StartTreeConfigEditor_TreeNodeFragment
		...visibilityTreeConfigEditor_TreeNodeFragment
	}
`;

type OwnProps = {
	treeNodeFragmentRef: TreeConfigEditor_TreeNodeFragment$key;
};

export const TreeConfigEditor = ({ treeNodeFragmentRef }: OwnProps) => {
	const { t } = useTranslation("common");
	const treeNodeFragment = useFragment<TreeConfigEditor_TreeNodeFragment$key>(
		TREE_NODE_FRAGMENT,
		treeNodeFragmentRef,
	);

	return (
		<>
			<h2>
				{t("educationalOffer.onLevel", { level: TREE_I18N_MAP(TREE_I18N_KEY.treeLevel) })}
			</h2>
			<StartTreeConfigEditor treeNodeFragmentRef={treeNodeFragment} />
			<VisibilityTreeConfigEditor treeNodeFragmentRef={treeNodeFragment} />
		</>
	);
};
